// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iQDR","controls":"styles_controls__1dyEC","charLimit":"styles_charLimit__1UqY5","input":"styles_input__1uacQ","send":"styles_send__3fRZ6"};